import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';
import { forkJoin, merge } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { PopupComponent } from '../components/popup/popup.component';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthPopupService {
    private _popup: MatDialogRef<PopupComponent> | undefined;

    constructor(
        private readonly _dialog: MatDialog,
        private readonly _auth: AuthService,
        private readonly _snackBar: MatSnackBar,
        private readonly _transloco: TranslocoService
    ) {
        merge(this._auth.accountCreated$, this._auth.successfulSignIn$)
            .pipe(
                switchMap(() =>
                    this._transloco
                        .selectTranslate('auth.snack.signed-in')
                        .pipe(first())
                )
            )
            .subscribe((message) => {
                this._popup?.close();

                this._snackBar.open(message, undefined, {
                    duration: 4000
                });
            });

        this._auth.tokenExpiration$
            .pipe(
                switchMap(() =>
                    forkJoin([
                        this._transloco
                            .selectTranslate('auth.snack.session-expired')
                            .pipe(first()),
                        this._transloco
                            .selectTranslate('shared.link.sign-in')
                            .pipe(first())
                    ])
                )
            )
            .subscribe(([message, action]) => {
                const snack = this._snackBar.open(message, action);
                snack.onAction().subscribe(() => this.showSignIn());
            });
    }

    showSignIn() {
        this._popup = this._dialog.open(PopupComponent);
    }

    showAccountCreation() {
        this._popup = this._dialog.open(PopupComponent, {
            data: { signUp: true }
        });
    }
}
